import axios from "axios";
import { SERVER_URL } from "../const";

/**
 * Fetches the currently active maintenance notice for the logged-in user.
 * Called once on app load. Returns { data: notice | null, msg: string }.
 */
export const getActiveMaintenanceNotice = async (token) => {
  const response = await axios.get(`${SERVER_URL}/maintenance-notice/active`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Lists all maintenance notices. Superadmin only.
 */
export const getAllMaintenanceNotices = async (token) => {
  const response = await axios.get(`${SERVER_URL}/maintenance-notice`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Creates a new maintenance notice. Superadmin only.
 * @param {string} token
 * @param {{ title, message, severity, is_active, is_dismissible, start_time, end_time }} payload
 */
export const createMaintenanceNotice = async (token, payload) => {
  const response = await axios.post(`${SERVER_URL}/maintenance-notice`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Partially updates a maintenance notice. Superadmin only.
 * Pass only the fields you want to change (all are optional).
 * @param {string} token
 * @param {number} noticeId
 * @param {Partial<{ title, message, severity, is_active, is_dismissible, start_time, end_time }>} payload
 */
export const updateMaintenanceNotice = async (token, noticeId, payload) => {
  const response = await axios.put(`${SERVER_URL}/maintenance-notice/${noticeId}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

/**
 * Hard-deletes a maintenance notice. Superadmin only.
 * Prefer deactivating (updateMaintenanceNotice with is_active: false) when you want an audit trail.
 */
export const deleteMaintenanceNotice = async (token, noticeId) => {
  const response = await axios.delete(`${SERVER_URL}/maintenance-notice/${noticeId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
